<template>
  <v-container fluid class="admin-member">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_user.title') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               class="mr-4"
               @click="exportUsers"
               v-if="$hasPermission('hkiarace.edit_member')">
          {{ $t('admin_user.export_user') }}
        </v-btn>
        <v-btn color="primary"
               @click="addMemberModalShown = true"
               v-if="$hasPermission('hkiarace.edit_member')">
          {{ $t('admin_user.add_user') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <MemberList full-height
                    :refresh-trigger.sync="refreshTrigger"
                    @filter="onMemberListFilterChanged"
                    @edit="onMemberEdit"
                    @verify="onMemberValidate"></MemberList>
      </v-col>
    </v-row>

    <AddMemberModal :shown="addMemberModalShown"
                    @cancel="addMemberModalShown = false"
                    @finish="onAddMemberModalFinish"></AddMemberModal>

    <EditMemberModal :shown="editMemberModalShown"
                     :account-id="editingMemberId"
                     @cancel="editMemberModalShown = false"
                     @finish="onEditMemberModalFinish"></EditMemberModal>

    <ValidateMemberModal :shown="validateMemberModalShown"
                         :account-id="validatingMemberId"
                         @cancel="validateMemberModalShown = false"
                         @finish="onValidateMemberModalFinish"></ValidateMemberModal>
  </v-container>
</template>

<script>
import {ref} from '@vue/composition-api';
import MemberList from "@/components/member/MemberList";
import AddMemberModal from "@/components/member/AddMemberModal";
import EditMemberModal from "@/components/member/EditMemberModal";
import ValidateMemberModal from "@/components/member/ValidateMemberModal";

export default {
  name: 'Member',
  components: {ValidateMemberModal, EditMemberModal, AddMemberModal, MemberList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const memberListFilters = ref(null);
    const onMemberListFilterChanged = function (filters) {
      memberListFilters.value = filters;
    }

    const exportUsers = function () {
      root.$callAPI('hkiarace/admin/user/export/', {
        filters: memberListFilters.value,
      }, function (response) {
        let blob = new Blob([response.data], {type: response.headers.get('content-type')});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'users.xlsx';
        link.click();
      }, null, false, {responseType: 'arraybuffer', timeout: 300000});
    };

    const addMemberModalShown = ref(false);
    const onAddMemberModalFinish = function (item) {
      addMemberModalShown.value = false;
      refresh();
      onMemberEdit(item);
    }


    const editingMemberId = ref(null);
    const editMemberModalShown = ref(false);
    const onMemberEdit = function (item) {
      editingMemberId.value = item.account.id;
      editMemberModalShown.value = true;
    };
    const onEditMemberModalFinish = function () {
      editMemberModalShown.value = false;
      refresh();
    }

    const validatingMemberId = ref(null);
    const validateMemberModalShown = ref(false);
    const onMemberValidate = function (item) {
      validatingMemberId.value = item.account.id;
      validateMemberModalShown.value = true;
    };
    const onValidateMemberModalFinish = function () {
      validateMemberModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      exportUsers,

      addMemberModalShown,
      onAddMemberModalFinish,

      onMemberListFilterChanged,

      editingMemberId,
      editMemberModalShown,
      onMemberEdit,
      onEditMemberModalFinish,

      validatingMemberId,
      validateMemberModalShown,
      onMemberValidate,
      onValidateMemberModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-member {
  height: calc(100% - 110px);
  display: flex;
  flex-direction: column;

  .admin-member-main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
